import { render, staticRenderFns } from "./AttachmentList.vue?vue&type=template&id=47985f0c&lang=pug&"
import script from "./AttachmentList.vue?vue&type=script&lang=js&"
export * from "./AttachmentList.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports